import { beginLightning, endLightning, store, ActionType } from 'owa-lightning-core-v2';
import EventEmitter from 'owa-event-emitter';

/**
 * Lightning properties
 */
export interface LightningProps {
    lid: string;
    when: (lightup: () => void) => void;
    series?: string[];
}

export function lightable<T extends Function>(target: T): T {
    let render = target.prototype.render;

    target.prototype.render = function() {
        if (store.unseenItems) {
            let viewState = store.unseenItems.get(this.props.lid);

            if (viewState && viewState.visible) {
                return render.call(this, arguments);
            }
        }

        return null;
    };

    let onMount = target.prototype.componentDidMount;

    target.prototype.componentDidMount = function() {
        if (onMount) {
            onMount.call(this, arguments);
        }

        beginLightning.importAndExecute(this.props.lid, this.props.when, this.props.series);
    };

    let onUnmount = target.prototype.componentWillUnmount;

    target.prototype.componentWillUnmount = function() {
        if (onUnmount) {
            onUnmount.call(this, arguments);
        }

        endLightning.importAndExecute(this.props.lid);
    };

    return target;
}

export function lighted(lid: string, actionType?: ActionType): void {
    endLightning.importAndExecute(lid, actionType);
}

export var eventMgr: EventEmitter = new EventEmitter();
export var SettingPanelFirstRunCalloutDismissedEvent: string =
    'SettingPanelFirstRunCalloutDismissed';
